import { Link } from "react-router-dom";
import { Code2, Mail, Phone, MapPin, ArrowUpRight } from "lucide-react";
import { Separator } from "../components/ui/separator";

const footerLinks = {
  Services: [
    { name: "Software Development", path: "/services" },
    { name: "Application Hosting", path: "/services" },
    { name: "Maintenance & Support", path: "/services" },
    { name: "UI/UX Design", path: "/services" },
  ],
  Company: [
    { name: "About Us", path: "/about" },
    { name: "Our Team", path: "/team" },
    { name: "Careers", path: "/careers" },
    { name: "Blog", path: "/blog" },
  ],
  Products: [
    { name: "Vidyora", path: "/vidyora" },
  ],
};

export default function Footer() {
  return (
    <footer data-testid="footer" className="relative bg-slate-950 border-t border-slate-800/50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 lg:py-20">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-12 lg:gap-8">
          {/* Brand Column */}
          <div className="lg:col-span-2 space-y-6">
            <Link to="/" className="flex items-center gap-2 group">
              <div className="w-9 h-9 rounded-lg bg-indigo-600 flex items-center justify-center">
                <Code2 className="w-5 h-5 text-white" />
              </div>
              <span className="font-['Outfit'] font-bold text-lg text-slate-50">
                Scriptovative
              </span>
            </Link>
            <p className="text-slate-400 text-sm leading-relaxed max-w-sm">
              Scriptovative Technologies Pvt. Ltd. — Engineering digital excellence 
              through precision software development, reliable hosting, and 
              dedicated application maintenance.
            </p>
            <div className="space-y-3">
              <a href="mailto:admin@scriptovative.com" className="flex items-center gap-3 text-slate-400 hover:text-indigo-400 transition-colors text-sm" data-testid="footer-email">
                <Mail className="w-4 h-4" />
                admin@scriptovative.com
              </a>
              <a href="tel:+919392047912" className="flex items-center gap-3 text-slate-400 hover:text-indigo-400 transition-colors text-sm" data-testid="footer-phone">
                <Phone className="w-4 h-4" />
                +91 9392047912
              </a>
              <div className="flex items-center gap-3 text-slate-400 text-sm">
                <MapPin className="w-4 h-4 flex-shrink-0" />
                Hyderabad, Telangana, India
              </div>
            </div>
          </div>

          {/* Link Columns */}
          {Object.entries(footerLinks).map(([category, links]) => (
            <div key={category}>
              <h4 className="font-['Outfit'] font-semibold text-slate-200 text-sm uppercase tracking-wider mb-4">
                {category}
              </h4>
              <ul className="space-y-3">
                {links.map((link) => (
                  <li key={link.name}>
                    <Link
                      to={link.path}
                      data-testid={`footer-link-${link.name.toLowerCase().replace(/\s+/g, '-')}`}
                      className="text-slate-400 hover:text-slate-200 text-sm transition-colors flex items-center gap-1 group"
                    >
                      {link.name}
                      <ArrowUpRight className="w-3 h-3 opacity-0 group-hover:opacity-100 transition-opacity" />
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <Separator className="my-10 bg-slate-800/50" />

        <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-slate-500 text-sm">
            &copy; {new Date().getFullYear()} Scriptovative Technologies Pvt. Ltd. All rights reserved.
          </p>
          <div className="flex items-center gap-6">
            <Link to="/about" className="text-slate-500 hover:text-slate-300 text-sm transition-colors">
              Privacy Policy
            </Link>
            <Link to="/about" className="text-slate-500 hover:text-slate-300 text-sm transition-colors">
              Terms of Service
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
